import { useMediaQuery, Box, Typography, Divider, Grid, TextField, useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Participants, ToolsDetails } from '../../../../../../components/custom';
import { CustomAlert } from '../../../../../../components/shared';
import { LayoutBase } from '../../../../../../layouts';
import { IInternalTraining, InternalTrainingServices, IParticipantes } from '../../../../../../services/api/action-plan/InternalTraining';
import { useAuthContext } from '../../../../../../context';

export const SemiannualInternalTrainingDetails = () => {

    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });

    const { userData } = useAuthContext();

    const url = useParams();
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const location = useLocation();
    const [valid, setValid] = useState<boolean>(false);

    const [data, setData] = useState<IInternalTraining>({
        periodo_referencia: '',
        data_treinamento: '',
        responsavel_tecnico: '',
        art: '',
        participantes: [],
        id_barragem: '',
    });

    useEffect(() => {
        setData({
            periodo_referencia: '',
            data_treinamento: '',
            responsavel_tecnico: '',
            art: '',
            participantes: [],
            id_barragem: '',
        });
        fetchData();
    }, [location.pathname]);

    function verifyForm() {
        return !!data.periodo_referencia && !!data.data_treinamento && !!data.responsavel_tecnico;
    }

    const handleNew = () => {
        navigate(`/information_dam/${url.id}/semiannual_internal_training/detalhes/novo`);
    };

    const fetchData = () => {
        if (url.idTraining) {
            InternalTrainingServices.get(url.idTraining)
                .then((response) => {
                    if (response instanceof Error) {
                        console.log(response.message);
                    } else {
                        response.data_treinamento = response.data_treinamento ? new Date(response.data_treinamento).toISOString().substring(0, 10) : '';
                        response.periodo_referencia = response.periodo_referencia ? new Date(response.periodo_referencia).toISOString().substring(0, 10) : '';
                        setData(response);
                    }
                });
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        const newData = {
            ...data,
            [name]: value,
        };
        setData(newData);
        setValid(false);
    };

    const handleParticipants = (value: IParticipantes[]) => {
        setData(prevData => { if (prevData) { return { ...prevData, participantes: value }; } return { participantes: value } as IInternalTraining; });
    };


    const handleSave = () => {
        setAlertInfo({ open: false, message: 'Registro Atualizado', severity: 'success' });
        if (url.idTraining == 'novo') {
            if (verifyForm()) {
                if (url.id) {
                    data.id_barragem = url.id;
                    InternalTrainingServices.create(data)
                        .then((response) => {
                            if (response instanceof Error) {
                                setAlertInfo({ open: true, message: `Error: ${response.message}`, severity: 'error' });
                            } else {
                                setAlertInfo({ open: true, message: 'Registro Criado', severity: 'success' });
                                setTimeout(() => {
                                    navigate(`/information_dam/${url.id}/semiannual_internal_training`);
                                }, 2000);
                            }
                        });
                }
            } else {
                setValid(true);
            }
        } else {
            if (url.idTraining !== undefined) {
                delete data.uuid;
                InternalTrainingServices.upgrade(data, url.idTraining)
                    .then((response) => {
                        if (response instanceof Error) {
                            setAlertInfo({ open: true, message: `Error: ${response.message}`, severity: 'error' });
                        } else {
                            setAlertInfo({ open: true, message: 'Registro Atualizado', severity: 'success' });
                            setTimeout(() => {
                                navigate(`/information_dam/${url.id}/semiannual_internal_training`);
                            }, 2000);
                        }
                    });
            }
        }
    };


    const handleDelete = () => {
        if (url.idAco !== undefined && url.idAco !== 'novo') {
            InternalTrainingServices.delet(url.idAco)
                .then((response) => {
                    if (response instanceof Error) {
                        console.log(response.message);
                        setAlertInfo({ open: true, message: `Error: ${response.message}`, severity: 'error' });

                    } else {
                        setAlertInfo({ open: true, message: 'ACO excluido', severity: 'success' });
                    }
                });
        }
    };


    return (
        <LayoutBase
            title='Cadastro treinamento interno'
            tollBar={<ToolsDetails
                showDeletButton={!!userData.permissoes.includes('remove')}
                showSaveButton={!!userData.permissoes.includes('edit')}
                showNewButton={!!userData.permissoes.includes('add')}
                onClickSave={() => handleSave()}
                onClickDelet={() => handleDelete()}
                onClickNew={() => handleNew()}
            />}
        >
            <Box padding={1}>
                <Box
                    sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}
                    padding={1}
                >
                    <Typography><strong>Informações do Treinamento</strong></Typography>
                </Box>
                <Divider />
                <Grid container padding={2} spacing={2}>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            label='Data de treinamento'
                            type='date'
                            name='data_treinamento'
                            fullWidth
                            required
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleChange(e)}
                            value={data?.data_treinamento}
                            error={valid ? (data.data_treinamento == '' ? true : false) : false}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            label='Período de referência'
                            type='date'
                            name='periodo_referencia'
                            fullWidth
                            required
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleChange(e)}
                            value={data?.periodo_referencia}
                            error={valid ? (data.periodo_referencia == '' ? true : false) : false}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            label='Responsável técnico'
                            type='text'
                            name='responsavel_tecnico'
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleChange(e)}
                            value={data?.responsavel_tecnico}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            label='ART'
                            type='text'
                            name='art'
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleChange(e)}
                            value={data?.art}
                        />
                    </Grid>
                </Grid>
                <Box
                    sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}
                    padding={1}
                >
                    <Typography><strong>Participantes</strong></Typography>
                </Box>
                <Divider />
                <Box>
                    <Participants value={data.participantes} onChange={handleParticipants} smDown={smDown} />
                </Box>
            </Box>
            {alertInfo.open &&
                <CustomAlert
                    severity={alertInfo.severity}
                    message={alertInfo.message}
                />
            }
        </LayoutBase>
    );
};